import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const bpAssignedLinesHeaders: Record<string, EnhancedTableHeader> = {
  line_ExternalCode: {
    name: 'line_ExternalCode',
    title: 'Line Code ',
    type: EnhancedTableHeaderType.Text,
  },
  line_Name: {
    name: 'line_Name',
    title: 'Line',
    type: EnhancedTableHeaderType.Link,
    urlTemplate:
      '/plan/lines/{salesforceManagement_BusinessPartnerLine_LineId}',
    openUrlInNewTab: false,
  },
  line_Status: {
    name: 'line_Status',
    title: 'Line Status',
    type: EnhancedTableHeaderType.Text,
  },
  salesforceManagement_BusinessPartnerLine_LineCommissionType: {
    name: 'salesforceManagement_BusinessPartnerLine_LineCommissionType',
    title: 'Commission Type',
    type: EnhancedTableHeaderType.Text,
  },
  salesforceManagement_BusinessPartnerLine_ValueCurrency: {
    name: 'salesforceManagement_BusinessPartnerLine_ValueCurrency',
    title: 'Commission',
    type: EnhancedTableHeaderType.Text,
  },
  salesforceManagement_BusinessPartnerLine_ApplicableOn: {
    name: 'salesforceManagement_BusinessPartnerLine_ApplicableOn',
    title: 'Applicable On',
    type: EnhancedTableHeaderType.Text,
  },
  salesforceManagement_BusinessPartnerLine_CreditLimit: {
    name: 'salesforceManagement_BusinessPartnerLine_CreditLimit',
    title: 'Credit Limit',
    type: EnhancedTableHeaderType.Text,
  },
  salesforceManagement_BusinessPartnerLine_CreditLimitCurrency: {
    name: 'salesforceManagement_BusinessPartnerLine_CreditLimitCurrency',
    title: 'Credit Limit Currency',
    type: EnhancedTableHeaderType.Text,
  },
  salesforceManagement_BusinessPartnerLine_GracePeriod: {
    name: 'salesforceManagement_BusinessPartnerLine_GracePeriod',
    title: 'Grace Period (in days)',
    type: EnhancedTableHeaderType.Text,
  },
  salesforceManagement_BusinessPartnerLine_Status: {
    name: 'salesforceManagement_BusinessPartnerLine_Status',
    title: '',
    type: EnhancedTableHeaderType.Image,
    hasConditionalImage: true,
    variableOneImageKey:
      'https://ufa-cdn.baibars.club/ufa-app-portal/images/green-correct-img.png',
    variableTwoImageKey:
      'https://ufa-cdn.baibars.club/ufa-app-portal/images/red-clean-img.png',
  },
};
